import React, { useState, useEffect, useRef } from "react";
import { Row, Col } from "react-flexbox-grid";
import { Button, SelectField, Autocomplete, TextField } from "react-md";
import { Checkbox } from "@material-ui/core";
import FontIcon from "react-md/lib/FontIcons";
import { Select, MenuItem } from "@material-ui/core";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import { DatePicker } from "@material-ui/pickers";
import MomentUtils from "@date-io/moment";
import "../styles/index.css";
import UploadFileIcon from "../../../../../assets/icons/upload-file-icon.png";
import { EditorState, convertToRaw, ContentState } from "draft-js";
import Dialog from "@material-ui/core/Dialog";
import { Editor } from "react-draft-wysiwyg";
import draftToHtml from "draftjs-to-html";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import htmlToDraft from "html-to-draftjs";
import EventService from "../../../../../service/event/EventService";
import CreateServiceProviderUtil from "../services/CreateServiceProviderUtil";
import CreateServiceUtil from "../services/CreateServiceUtil";
import moment from "moment";
import MultipleSelectChip from "../helper/MultipleSelectChip";
import AuthenticationService from "../../../../../service/auth/AuthenticationService";
import AvailabilityCalendar from "../helper/AvailabilityCalendar";
import { getSpocTypeMenuItems } from "../helper/spocTypeMenuItems";
import SimpleBackdrop from "../helper/SimpleBackdrop";
import CityTable from "../helper/CityTable";

export const ServiceProviderGym = ({
  providerToCreate,
  setProviderToCreate,
  mode,
  handleUpdateMode,
  calendarHeadings,
  countries,
  verifyData,
  initialCityMapping,
  enableCityMappingTextRef,
}) => {
  const [serviceProviderMobileImage, setServiceProviderMobileImage] =
    useState(null);
  const [serviceProviderMobilePreview, setServiceProviderMobilePreview] =
    useState("");
  const [serviceProviderDesktopImage, setServiceProviderDesktopImage] =
    useState(null);
  const [serviceProviderDesktopPreview, setServiceProviderDesktopPreview] =
    useState("");
  const [editorState, setEditorState] = useState(EditorState.createEmpty());
  const [servicesSubTypeArr, setServicesSubTypeArr] = useState([]);
  const [servicesSubTypeObj, setServicesSubTypeObj] = useState([]);
  const [groupVendorTypeArr, setGroupVendorTypeArr] = useState([]);
  const [groupVendorTypeObj, setGroupVendorTypeObj] = useState([]);
  const [spocTypes, setSpocTypes] = useState([]);
  const [countryCodeArr, setCountryCodeArr] = useState([]);
  const [countryCodeObj, setCountryCodeObj] = useState([]);
  const [cityMappings, setCityMappings] = useState({});
  const [cityMappingFilters, setCityMappingFilters] = useState({});
  const [cityFormData, setCityFormData] = useState({});
  const [showBackdrop, setShowBackdrop] = useState(false);
  const [loading, setLoading] = useState(false);
  const [originalMode, setOriginalMode] = useState(mode);
  const [citySectionMode, setCitySectionMode] = useState(mode);
  const [altEmail, setAltEmail] = useState([]);
  const [cityMappingOperationSelected, setCityMappingOperationSelected] =
    useState(null); // 1 -> add, 2 -> update/edit
  const [errorObject, setErrorObject] = useState(null);
  const [tableDataEditAudits, setTableDataEditAudits] = useState({});
  const [newTableDataEditAudits, setNewTableDataEditAudits] = useState({});
  const [spocDetails, setSpocDetails] = useState([
    {
      name: "",
      countryCode: 91,
      phoneNo: "",
      emailId: "",
      landline: "",
      spocType: "",
    },
  ]);
  const createServiceProviderUtil = new CreateServiceProviderUtil();
  const createServiceUtil = new CreateServiceUtil();
  const serviceProviderMobileImageInputRef = useRef(null);
  const serviceProviderDesktopImageInputRef = useRef(null);

  useEffect(() => {
    getServiceSubType();
    getGroupVendor(providerToCreate?.serviceTypeId);
    getSpocTypes(providerToCreate?.serviceTypeId);
    setCountryCodeArr(countries);
    if (mode == 2 || mode == 3) {
      fetchCityMappings(providerToCreate?.id, 1, {});
      setServiceProviderMobilePreview(
        providerToCreate?.gymInfo?.identityDetails?.mobileCover,
      );
      setServiceProviderDesktopPreview(
        providerToCreate?.gymInfo?.identityDetails?.desktopCover,
      );
      let contentBlock = htmlToDraft(
        providerToCreate?.gymInfo?.identityDetails?.longDescription,
      );
      if (contentBlock) {
        let contentState = ContentState.createFromBlockArray(
          contentBlock.contentBlocks,
        );
        let editorState = EditorState.createWithContent(contentState);
        setEditorState(editorState);
      }
      if (
        providerToCreate.gymInfo.contactDetails.alternateBookingEmails &&
        providerToCreate.gymInfo.contactDetails.alternateBookingEmails.length >
          0
      ) {
        setAltEmail(
          providerToCreate.gymInfo.contactDetails.alternateBookingEmails,
        );
      }
      if (
        providerToCreate.gymInfo.contactDetails.spoc &&
        providerToCreate.gymInfo.contactDetails.spoc.length > 0
      ) {
        setSpocDetails(providerToCreate.gymInfo.contactDetails.spoc);
      }
    }
  }, []);
  useEffect(() => {
    let dropdownObj = servicesSubTypeArr.map((e) => {
      return {
        label: e.name,
        value: e.id,
      };
    });
    setServicesSubTypeObj(dropdownObj);
  }, [servicesSubTypeArr]);

  useEffect(() => {
    let dropdownObj = groupVendorTypeArr.map((e) => {
      return {
        label: e.name,
        value: e.name,
      };
    });
    setGroupVendorTypeObj(dropdownObj);
  }, [groupVendorTypeArr]);

  useEffect(() => {
    setProviderToCreate((prev) => {
      let providerToCreate = prev;
      return {
        ...providerToCreate,
        gymInfo: {
          ...providerToCreate.gymInfo,
          contactDetails: {
            ...providerToCreate.gymInfo.contactDetails,
            spoc: spocDetails,
          },
        },
      };
    });
  }, [spocDetails]);
  useEffect(() => {
    let dropdownObj = countryCodeArr?.map((e) => {
      return {
        label: `+${e.code}`,
        value: e.code,
      };
    });

    setCountryCodeObj(dropdownObj);
  }, [countryCodeArr]);

  useEffect(() => {
    if (serviceProviderMobileImage != null) {
      setShowBackdrop(true);
      uploadImage(serviceProviderMobileImage)
        .then((e) => {
          setServiceProviderMobilePreview(e);
          let obj = {
            ...providerToCreate,
            gymInfo: {
              ...providerToCreate.gymInfo,
              identityDetails: {
                ...providerToCreate.gymInfo.identityDetails,
                mobileCover: e,
              },
            },
          };
          setProviderToCreate(obj);
          setTimeout(() => {
            setShowBackdrop(false);
          }, 500);
        })
        .catch((err) => {
          setTimeout(() => {
            setShowBackdrop(false);
            EventService.emit("showError", {
              message: `Error while uploading the plan mobile image: ${err}`,
            });
          }, 500);
        });
    }
  }, [serviceProviderMobileImage]);
  useEffect(() => {
    if (serviceProviderDesktopImage != null) {
      setShowBackdrop(true);
      uploadImage(serviceProviderDesktopImage)
        .then((e) => {
          setServiceProviderDesktopPreview(e);
          let obj = {
            ...providerToCreate,
            gymInfo: {
              ...providerToCreate.gymInfo,
              identityDetails: {
                ...providerToCreate.gymInfo.identityDetails,
                desktopCover: e,
              },
            },
          };
          setProviderToCreate(obj);
          setTimeout(() => {
            setShowBackdrop(false);
          }, 500);
        })
        .catch((err) => {
          setTimeout(() => {
            setShowBackdrop(false);
            EventService.emit("showError", {
              message: `Error while uploading the plan desktop image: ${err}`,
            });
          }, 500);
        });
    }
  }, [serviceProviderDesktopImage]);

  useEffect(() => {
    setProviderToCreate((prev) => {
      let providerToCreate = prev;
      return {
        ...providerToCreate,
        gymInfo: {
          ...providerToCreate.gymInfo,
          contactDetails: {
            ...providerToCreate.gymInfo.contactDetails,
            alternateBookingEmails: altEmail,
          },
        },
      };
    });
  }, [altEmail]);

  const handleUpdateTableCityEntity = (cityEntity, cityEntityOld) => {
    if (cityEntity?.id) {
      // if (cityEntity?.status === 3) {
      //   // delete entry from city Mappings
      //   const updatedCityMappings = (cityMappings?.cityEntities ?? []).filter(
      //     (item) => item.id !== cityEntity.id
      //   );
      //   setCityMappings((prev) => ({
      //     ...prev,
      //     cityEntities: updatedCityMappings,
      //   }));
      //   return;
      // }

      // checking whether it already exist in audits.. if yes , then it means it not the original value recieved from backend it has been updated atleast once on local.
      if (!Boolean(tableDataEditAudits?.[cityEntity.id])) {
        cityEntity["originalEntity"] = cityEntityOld;
      }

      setTableDataEditAudits((prev) => ({
        ...prev,
        [cityEntity.id]: cityEntity,
      }));
    }
  };

  const handleUpdateNewTableCityEntity = (cityEntity, cityEntityOld) => {
    if (cityEntity?.id) {
      if (cityEntity?.status === 3) {
        // delete entry from city Mappings
        const updatedCityMappings = (cityFormData?.cityMappings ?? []).filter(
          (item) => item.id !== cityEntity.id,
        );
        setCityFormData((prev) => ({
          ...prev,
          cityMappings: updatedCityMappings,
        }));
        return;
      }
      setNewTableDataEditAudits((prev) => ({
        ...prev,
        [cityEntity.id]: cityEntity,
      }));
    }
  };

  function generateId() {
    return Date.now().toString(36) + Math.random().toString(36).substr(2, 9);
  }

  const returnTableDataWithEditsApplied = (
    cityMappings,
    tableDataEditAudits,
  ) => {
    return mergeUpdates(cityMappings?.cityEntities ?? [], tableDataEditAudits);
  };

  const returnNewTableDataWithEditsApplied = (
    cityMappingsArray,
    newTableDataEditAudits,
  ) => {
    return mergeUpdates(cityMappingsArray ?? [], newTableDataEditAudits);
  };

  const returnTableDataWithEditsAppliedWithOnlyEditedEntities = (
    cityMappings,
    tableDataEditAudits,
  ) => {
    return mergeUpdatesWithOnlyEditedEntities(
      cityMappings?.cityEntities ?? [],
      tableDataEditAudits,
    );
  };

  const mergeUpdates = (data, audits) => {
    const mergedData = data.map((item) => {
      const audit = audits[item.id];
      return audit
        ? { ...item, ...audit } // merge original and audit (audit overrides)
        : item; // no change if no matching audit
    });
    // removing Deleted
    const finalCityMappings = (mergedData ?? []).filter(
      (item) => item?.status !== 3,
    );
    return finalCityMappings;
  };

  const mergeUpdatesWithOnlyEditedEntities = (data, audits) => {
    // removing Deleted & entities with no change
    const finalCityMappings = (Object.values(audits ?? {}) ?? [])?.filter(
      (item) =>
        item?.status !== item?.originalEntity?.status ||
        item?.city !== item?.originalEntity?.city,
    );
    return finalCityMappings;
  };

  let checkIfThereIsAnythingToAdd = () => {
    return (
      cityMappingOperationSelected === 1 &&
      (
        returnNewTableDataWithEditsApplied(
          cityFormData?.cityMappings ?? [],
          newTableDataEditAudits ?? {},
        ) ?? []
      ).length > 0
    );
  };

  let checkIfThereIsAnythingToUpdate = () => {
    return (
      cityMappingOperationSelected === 2 &&
      (
        returnTableDataWithEditsAppliedWithOnlyEditedEntities(
          cityMappings ?? {},
          tableDataEditAudits ?? {},
        ) ?? []
      ).length > 0
    );
  };

  let addSPCityMapping = () => {
    setLoading(true);
    let onResponse = (res) => {
      setLoading(false);
      if ((res?.totalErrors ?? 0) > 0) {
        setErrorObject((prev) => ({
          operation: 1,
          errorResponse: res?.errorResponse,
          totalRequested: res?.totalRequested,
          totalErrors: res?.totalErrors,
        }));
        EventService.emit("showError", {
          message: `City mappings added partially with ${
            res?.totalErrors ?? 0
          } errors`,
        });
      } else {
        EventService.emit("showError", {
          message: `City mappings added successfully`,
        });
      }
      setCityFormData((prev) => {});
      fetchCityMappings(providerToCreate?.id, 1, {});
    };
    let onError = (err) => {
      setLoading(false);
      EventService.emit("showError", {
        message: `Error: ${err?.message}`,
      });
    };
    createServiceProviderUtil.addSPCityMapping(
      {
        serviceProviderId: providerToCreate?.id,
        cityEntities: (
          returnNewTableDataWithEditsApplied(
            cityFormData?.cityMappings ?? [],
            newTableDataEditAudits ?? {},
          ) ?? []
        ).map(({ city, status, externalCentreId, externalCityId }) => ({
          city,
          externalCentreId,
          externalCityId,
          status,
        })),
      },
      onResponse,
      onError,
    );
  };

  let updateSPCityMapping = () => {
    setLoading(true);
    let onResponse = (res) => {
      setLoading(false);
      if ((res?.totalErrors ?? 0) > 0) {
        setErrorObject((prev) => ({
          operation: 2,
          errorResponse: res?.errorResponse,
          totalRequested: res?.totalRequested,
          totalErrors: res?.totalErrors,
        }));
        EventService.emit("showError", {
          message: `City mappings updated partially with ${
            res?.totalErrors ?? 0
          } errors`,
        });
      } else {
        EventService.emit("showError", {
          message: `City mappings updated successfully`,
        });
      }
      setTableDataEditAudits((prev) => {});
      fetchCityMappings(providerToCreate?.id, 1, {});
    };
    let onError = (err) => {
      setLoading(false);
      EventService.emit("showError", {
        message: `Error: ${err?.message}`,
      });
    };
    createServiceProviderUtil.updateSPCityMapping(
      {
        updateRequest: (
          returnTableDataWithEditsAppliedWithOnlyEditedEntities(
            cityMappings ?? {},
            tableDataEditAudits ?? {},
          ) ?? []
        ).map(({ id, city, status }) => ({
          id,
          city,
          status,
        })),
      },
      onResponse,
      onError,
    );
  };

  let getServiceSubType = () => {
    if (mode == 1) {
      setProviderToCreate({
        ...providerToCreate,
        gymInfo: {
          ...providerToCreate.gymInfo,
          vendorGroup: {
            ...providerToCreate.gymInfo.vendorGroup,
            isVendorGroup: false,
          },
          amenities: {
            breakfastAvailable: false,
          },
          otherInfo: {
            advancePaymentRequired: false,
            autoBookingConfirmation: false,
          },
        },
      });
    }
    let onResponse = (res) => {
      setServicesSubTypeArr((prev) => {
        const updatedState = [...res];
        return updatedState;
      });
    };
    let onError = (err) => {
      EventService.emit("showError", {
        message: `Error: ${err?.message}`,
      });
    };
    if (providerToCreate?.serviceSubtypeId !== 0) {
      createServiceUtil.getServiceSubType(
        providerToCreate?.serviceTypeId,
        true,
        onResponse,
        onError,
      );
    }
  };
  const phoneNoLen = (cc) => {
    return countries?.find((c) => c.code == cc).phoneNoLen;
  };

  let getGroupVendor = (serviceTypeId) => {
    let onResponse = (res) => {
      if (res != null) {
        setGroupVendorTypeArr((prev) => {
          const updatedState = [...res];
          return updatedState;
        });
      }
    };
    let onError = (err) => {
      EventService.emit("showError", {
        message: `Error: ${err?.message}`,
      });
    };
    createServiceProviderUtil.getGroupVendorsByFilter(
      {
        serviceTypeId: serviceTypeId,
        status: true,
      },
      onResponse,
      onError,
    );
  };

  let getSpocTypes = (serviceTypeId) => {
    let onResponse = (res) => {
      if (res != null) {
        setSpocTypes(res);
      }
    };
    let onError = (err) => {
      EventService.emit("showError", {
        message: `Error: ${err?.message}`,
      });
    };
    createServiceProviderUtil.getSpocTypes(
      serviceTypeId,
      true,
      onResponse,
      onError,
    );
  };

  let fetchCityMappings = (serviceProviderId, pageNo, filters) => {
    setCityMappingFilters((prev) => ({ ...prev, ...filters }));
    setLoading(true);

    let onResponse = (res) => {
      setLoading(false);
      if (res != null) {
        setCityMappings((prev) => res);
      }
    };
    let onError = (err) => {
      setLoading(false);
      EventService.emit("showError", {
        message: `Error: ${err?.message}`,
      });
    };
    createServiceProviderUtil.getCityMappingByFilter(
      {
        pageNo: pageNo,
        pageSize: 30,
        serviceProviderId: serviceProviderId, // always mandatory, rest are optional
        status: (filters?.status ?? [])?.map((ele) => ele.value) ?? [], // multiple supported as array
        name: filters?.name ?? "", // regex substring supported
      },
      onResponse,
      onError,
    );
  };

  const uploadImage = (file) => {
    return new Promise((resolve, reject) => {
      const data = new FormData();
      data.append("file", file, file.name);

      createServiceUtil.uploadImg(
        data,
        (res) => {
          resolve(res.publicUrl);
        },
        (err) => {
          reject(err);
        },
      );
    });
  };

  const addSpocRow = () => {
    setSpocDetails([
      ...spocDetails,
      {
        name: "",
        countryCode: 91,
        phoneNo: "",
        emailId: "",
        landline: "",
        spocType: "",
      },
    ]);
  };
  const removeSpocRow = (index) => {
    setSpocDetails((prev) => prev.filter((_, i) => i !== index));
  };
  const setSpocData = (e, index) => {
    setSpocDetails((prev) => prev.map((item, i) => (i === index ? e : item)));
  };
  const addAlternateEmail = () => {
    if (altEmail == []) {
      setAltEmail([""]);
    } else {
      setAltEmail([...altEmail, ""]);
    }
  };
  const removeAltEmail = (index) => {
    setAltEmail((prev) => prev.filter((_, i) => i !== index));
  };
  const setAltEmails = (e, index) => {
    setAltEmail((prev) => prev.map((item, i) => (i === index ? e : item)));
  };

  const serviceProviderMobileUploadClick = () => {
    if (serviceProviderMobileImageInputRef.current) {
      serviceProviderMobileImageInputRef.current.click();
    }
  };

  const serviceProviderMobileImageSelected = (event) => {
    const file = event.target.files[0];

    if (!file) {
      console.log("No file selected or file picker was canceled");
      return;
    }

    const maxSize = 20 * 1024 * 1024; // 20MB
    if (file.size > maxSize) {
      EventService.emit("showError", {
        message: "File size cannot be more than 20MB",
      });
      return;
    }
    const img = new Image();
    img.onload = function () {
      if (this.width !== 1080 || this.height !== 1080) {
        EventService.emit("showError", {
          message: "Image dimensions must be 1080x1080 pixels",
        });
        return;
      }
      setServiceProviderMobileImage(file);
    };
    img.src = URL.createObjectURL(file);
  };
  const serviceProviderDesktopUploadClick = () => {
    if (serviceProviderDesktopImageInputRef.current) {
      serviceProviderDesktopImageInputRef.current.click();
    }
  };

  const serviceProviderDesktopImageSelected = (event) => {
    const file = event.target.files[0];

    if (!file) {
      console.log("No file selected or file picker was canceled");
      return;
    }

    const maxSize = 20 * 1024 * 1024; // 20MB
    if (file.size > maxSize) {
      EventService.emit("showError", {
        message: "File size cannot be more than 20MB",
      });
      return;
    }
    const img = new Image();
    img.onload = function () {
      if (this.width !== 1080 || this.height !== 1080) {
        EventService.emit("showError", {
          message: "Image dimensions must be 1080x1080 pixels",
        });
        return;
      }
      setServiceProviderDesktopImage(file);
    };
    img.src = URL.createObjectURL(file);
  };
  let SERVICE_PROVIDER_STATUS = [
    {
      label: "Active",
      value: "true",
    },
    {
      label: "Inactive",
      value: "false",
    },
  ];

  let SERVICE_PROVIDER_CITY_OPERATIONS = [
    {
      label: "Add cities",
      value: 1,
    },
    {
      label: "Edit cities",
      value: 2,
    },
  ];

  const _onEditorStateChange = (editorState) => {
    let body = draftToHtml(convertToRaw(editorState.getCurrentContent()));
    setProviderToCreate({
      ...providerToCreate,
      gymInfo: {
        ...providerToCreate.gymInfo,
        identityDetails: {
          ...providerToCreate.gymInfo.identityDetails,
          longDescription: body,
        },
      },
    });
    setEditorState(editorState);
  };

  const fetchPincodeDetails = (pincode) => {
    let onResponse = (res) => {
      setProviderToCreate({
        ...providerToCreate,
        gymInfo: {
          ...providerToCreate.gymInfo,
          address: {
            ...providerToCreate.gymInfo.address,
            pincode: res.pincode,
            district: res.district,
            state: res.state,
          },
        },
      });
    };
    let onError = (err) => {
      EventService.emit("showError", {
        message: `Error: ${err?.message}`,
      });
    };
    createServiceProviderUtil.getPincodeDetails(pincode, onResponse, onError);
  };

  let setAvailability = (availability1) => {
    setProviderToCreate({
      ...providerToCreate,
      gymInfo: {
        ...providerToCreate.gymInfo,
        availability: availability1,
      },
    });
  };

  const resetAddOrUpdateCities = () => {
    setTableDataEditAudits({});
    setNewTableDataEditAudits({});
    setCityFormData({});
  };

  return (
    <>
      <div style={{ height: "20px" }} />

      <Row>
        {Boolean(providerToCreate?.serviceSubtypeId !== 0) && (
          <Col xs={12} sm={3} md={3} lg={3}>
            <div
              className="mp-create-service-field-container"
              id="provider_subtype"
            >
              <div className="mp-label">
                {`Provider subtype`} <label className="mp-label-red"> *</label>
              </div>
              <div>
                <SelectField
                  placeholder={"Select"}
                  disabled={mode == 2 || mode == 3}
                  className="mp-select-field"
                  menuItems={servicesSubTypeObj}
                  value={providerToCreate?.serviceSubtypeId}
                  onChange={(e) => {
                    setProviderToCreate({
                      ...providerToCreate,
                      serviceSubtypeId: Number(e),
                    });
                  }}
                />
              </div>
            </div>
          </Col>
        )}
        {Boolean(providerToCreate?.serviceSubtypeId !== 0) && (
          <Col xs={12} sm={1} md={1} lg={1}>
            <div style={{ height: "20px" }}></div>
          </Col>
        )}

        <Col xs={12} sm={3} md={3} lg={3}>
          <div className="mp-field-container" id="provider_status">
            <div className="mp-label">
              {`Status`}
              <label className="mp-label-red"> *</label>
            </div>
            <div>
              <SelectField
                id={"mp-service-provider-status"}
                placeholder="Select"
                disabled={mode == 2}
                className="mp-select-field"
                menuItems={SERVICE_PROVIDER_STATUS}
                // defaultValue={"true"}
                value={providerToCreate?.isActive}
                onChange={(e) =>
                  setProviderToCreate({ ...providerToCreate, isActive: e })
                }
              />
            </div>
          </div>
        </Col>
      </Row>
      <h3 className="mp-sub-heading-margin">{`Personal details`}</h3>
      <Row>
        <Col xs={12} sm={3} md={3} lg={3}>
          <div
            className="mp-create-service-field-container"
            id="service_provider_name"
          >
            <div className="mp-label">
              {`Service provider name`}
              <label className="mp-label-red"> *</label>
            </div>
            <div>
              <TextField
                id={"service_provider_name"}
                lineDirection="left"
                disabled={mode == 2}
                placeholder="This will be displayed on the app"
                value={`${
                  providerToCreate?.gymInfo?.identityDetails?.name != null
                    ? providerToCreate?.gymInfo?.identityDetails?.name
                    : ""
                }`}
                onChange={(e) => {
                  setProviderToCreate({
                    ...providerToCreate,
                    gymInfo: {
                      ...providerToCreate.gymInfo,
                      identityDetails: {
                        ...providerToCreate.gymInfo.identityDetails,
                        name: e,
                      },
                    },
                  });
                }}
              />
            </div>
          </div>
        </Col>
        <Col xs={12} sm={1} md={1} lg={1}>
          <div style={{ height: "20px" }}></div>
        </Col>

        <Col xs={12} sm={7} md={7} lg={7}>
          <div className="mp-field-container" id="service_provider_short">
            <div className="mp-label">
              {`Service provider short description (100 characters)`}
              {/* <label className="mp-label-red"> *</label> */}
            </div>
            <div>
              <TextField
                id="service_provider_short"
                disabled={mode == 2}
                value={
                  providerToCreate?.gymInfo?.identityDetails?.shortdescription
                    ? `${providerToCreate?.gymInfo?.identityDetails?.shortdescription}`
                    : ""
                }
                lineDirection="left"
                placeholder="Type here"
                onChange={(e) => {
                  if (e.length <= 100) {
                    setProviderToCreate({
                      ...providerToCreate,
                      gymInfo: {
                        ...providerToCreate.gymInfo,
                        identityDetails: {
                          ...providerToCreate.gymInfo.identityDetails,
                          shortdescription: e,
                        },
                      },
                    });
                  }
                }}
              />
            </div>
          </div>
        </Col>
      </Row>
      <div style={{ height: "20px" }} />
      <Row>
        <Col xs={12} sm={11} md={11} lg={11}>
          <div className="mp-field-container" id="service_provider_long">
            <div className="mp-label-2">
              {`Service provider long description`}
            </div>
            <div
              style={{ borderBottom: "2px solid #E4E4E4", marginTop: "10px" }}
              id="service_provider_long"
            >
              <Editor
                id="service_provider_long"
                // toolbarClassName={showToolbar ? null : "toolBar-hidden"}
                // toolbarClassName={showToolbar ? null : " toolBar-hidden-pn"}

                readOnly={mode == 2 ? true : false}
                editorState={editorState}
                wrapperClassName=""
                editorClassName=""
                // hashtag={{
                //   separator: " ",
                //   trigger: "#",
                // }}
                onEditorStateChange={_onEditorStateChange}
                stripPastedStyles={true}
                // placeholder={
                //   <label>{`Please enter service long description`}</label>
                // }
              />
            </div>
          </div>
        </Col>
      </Row>
      <div style={{ height: "20px" }} />
      <Row>
        <Col xs={12} sm={3} md={3} lg={3}>
          <div
            className="mp-create-service-field-container"
            id="image_mobile_view"
          >
            <div className="mp-label">
              {`Image (Mobile view)`}
              <label className="mp-label-red"> *</label>
            </div>
            <div className="mp-image-requirements">{`(Max file size: 20mb, dimension 1080*1080px)`}</div>
            <Button
              id="upload_image"
              raised
              disabled={mode == 2}
              className="mp-button-upload"
              onClick={() => {
                serviceProviderMobileUploadClick();
              }}
            >
              {serviceProviderMobilePreview == ""
                ? "Upload image"
                : "Update image"}
            </Button>
            <input
              type="file"
              accept="image/png, image/jpeg"
              ref={serviceProviderMobileImageInputRef}
              style={{ display: "none" }}
              onChange={serviceProviderMobileImageSelected}
            />
            <Col xs={12} sm={5} md={4} lg={4}>
              {serviceProviderMobilePreview &&
                serviceProviderMobilePreview != "" && (
                  <>
                    <div
                      style={{
                        display: "inline-block",
                        border: "1px solid black",
                        marginTop: "15px",
                        marginLeft: "-6px",
                      }}
                    >
                      <img
                        src={serviceProviderMobilePreview}
                        alt="Selected Preview"
                        style={{
                          width: "100px",
                          height: "auto",
                          display: "block",
                        }}
                      />
                    </div>
                  </>
                )}
            </Col>
          </div>
        </Col>
        <Col xs={12} sm={1} md={1} lg={1}>
          <div style={{ height: "20px" }}></div>
        </Col>
        <Col xs={12} sm={3} md={3} lg={3}>
          <div className="mp-create-service-field-container">
            <div className="mp-label">{`Image (Desktop view)`}</div>
            <div className="mp-image-requirements">{`(Max file size: 20mb, dimension 1080*1080px)`}</div>
            <Button
              raised
              disabled={mode == 2}
              className="mp-button-upload"
              onClick={() => {
                serviceProviderDesktopUploadClick();
              }}
            >
              {serviceProviderDesktopPreview == ""
                ? "Upload image"
                : "Update image"}
            </Button>
            <input
              type="file"
              accept="image/png, image/jpeg"
              ref={serviceProviderDesktopImageInputRef}
              style={{ display: "none" }}
              onChange={serviceProviderDesktopImageSelected}
            />
            <Col xs={12} sm={5} md={4} lg={4}>
              {serviceProviderDesktopPreview &&
                serviceProviderDesktopPreview != "" && (
                  <>
                    <div
                      style={{
                        display: "inline-block",
                        border: "1px solid black",
                        marginTop: "15px",
                        marginLeft: "-6px",
                      }}
                    >
                      <img
                        src={serviceProviderDesktopPreview}
                        alt="Selected Preview"
                        style={{
                          width: "100px",
                          height: "auto",
                          display: "block",
                        }}
                      />
                    </div>
                  </>
                )}
            </Col>
          </div>
        </Col>
      </Row>
      <div style={{ height: "20px" }} />
      <h3 className="mp-sub-heading-margin">{`Contact details`}</h3>
      <Row>
        <Col xs={12} sm={3} md={3} lg={3}>
          <div className="mp-field-container" id="booking_email_id">
            <div className="mp-label">
              {`Booking Email Id`}
              <label className="mp-label-red"> *</label>
            </div>

            <TextField
              id={"booking_email_id"}
              lineDirection="left"
              disabled={mode == 2}
              placeholder="Type here"
              value={
                providerToCreate?.gymInfo?.contactDetails?.bookingEmailId !=
                null
                  ? `${providerToCreate?.gymInfo?.contactDetails?.bookingEmailId}`
                  : ""
              }
              onChange={(e) => {
                setProviderToCreate({
                  ...providerToCreate,
                  gymInfo: {
                    ...providerToCreate.gymInfo,
                    contactDetails: {
                      ...providerToCreate.gymInfo.contactDetails,
                      bookingEmailId: e,
                    },
                  },
                });
              }}
            />
          </div>
          <div>
            <div
              className="mp-add-options"
              onClick={() => {
                if (mode != 2) {
                  addAlternateEmail();
                }
              }}
            >{`+ Add alternate email`}</div>
            {altEmail.map((e, index) => {
              return (
                <div>
                  <div className="mp-label" style={{ marginTop: "5px" }}>
                    {`Alternate email`}
                  </div>
                  <div className="mp-email-container">
                    <div style={{ flex: "1" }}>
                      <TextField
                        id={`service-provider-alt-email-${index}`}
                        lineDirection="left"
                        disabled={mode == 2}
                        value={e != null ? `${e}` : ""}
                        onChange={(e) => {
                          if (e.length <= 50) {
                            setAltEmails(e, index);
                          }
                        }}
                      />
                    </div>
                    <div
                      className="mp-alt-email-remove"
                      onClick={() => {
                        if (mode != 2) {
                          removeAltEmail(index);
                        }
                      }}
                    >
                      <FontIcon style={{ fontSize: "16px" }}>close</FontIcon>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </Col>
        <Col xs={12} sm={1} md={1} lg={1}>
          <div className="mp-between-two-side"></div>
        </Col>
        <Col xs={12} sm={3} md={3} lg={3}>
          <div className="mp-field-container">
            <div className="mp-label">{`Website link`}</div>

            <TextField
              id={"service-provider-contact-number-website"}
              lineDirection="left"
              disabled={mode == 2}
              placeholder="Type here"
              value={
                providerToCreate?.gymInfo?.contactDetails?.website != null
                  ? `${providerToCreate?.gymInfo?.contactDetails?.website}`
                  : ""
              }
              onChange={(e) => {
                setProviderToCreate({
                  ...providerToCreate,
                  gymInfo: {
                    ...providerToCreate.gymInfo,
                    contactDetails: {
                      ...providerToCreate.gymInfo.contactDetails,
                      website: e,
                    },
                  },
                });
              }}
            />
          </div>
        </Col>
      </Row>
      <div className="mp-spoc-heading-container">
        <h3 className="mp-sub-heading-margin">{`SPOC details`}</h3>
        <div
          className="mp-add-options"
          style={{ padding: "5px" }}
          onClick={() => {
            if (mode != 2) {
              addSpocRow();
            }
          }}
        >{`+ Add new`}</div>
      </div>
      <Row>
        {spocDetails.map((e, index) => {
          return (
            <>
              <Col xs={12} sm={3} md={3} lg={3}>
                <div
                  className="mp-field-container"
                  style={{ marginTop: "5px" }}
                  id="spoc_name"
                >
                  <div className="mp-label">
                    {`SPOC ${index + 1} full name`}
                    {index == 0 && <label className="mp-label-red"> *</label>}
                  </div>

                  <TextField
                    id={"spoc_name"}
                    lineDirection="left"
                    placeholder="Type here"
                    disabled={mode == 2}
                    value={e.name != "" ? e.name : ""}
                    onChange={(elem) => {
                      let data = { ...e, name: elem };
                      setSpocData(data, index);
                    }}
                  />
                </div>
              </Col>
              <Col xs={12} sm={1} md={1} lg={1}>
                <div className="mp-between-two-side"></div>
              </Col>
              <Col xs={12} sm={3} md={3} lg={3}>
                <div className="mp-field-container">
                  <div className="mp-label">
                    {`SPOC ${index + 1} contact number`}
                    {index == 0 && <label className="mp-label-red"> *</label>}
                  </div>
                  <div style={{ display: "flex" }}>
                    <div style={{ width: "40px", marginRight: "20px" }}>
                      <SelectField
                        id={`service_provider_spoc_contact_number_cc_${index}`}
                        placeholder="+XX"
                        disabled={mode == 2}
                        className="mp-select-field"
                        menuItems={countryCodeObj}
                        value={e.countryCode}
                        onChange={(elem) => {
                          let data = { ...e, countryCode: elem };
                          setSpocData(data, index);
                        }}
                      />
                    </div>
                    <div style={{ flex: "1" }}>
                      <TextField
                        id={"service_provider_spoc_contact_number_phone"}
                        lineDirection="left"
                        placeholder="Enter phone number"
                        disabled={mode == 2}
                        type="text"
                        value={e.phoneNo != "" ? e.phoneNo : ""}
                        onChange={(elem) => {
                          let value = elem.replace(/\D/g, "");
                          if (value.length <= phoneNoLen(e.countryCode)) {
                            let data = {
                              ...e,
                              phoneNo: value == "" ? "" : Number(value),
                            };
                            setSpocData(data, index);
                          }
                        }}
                      />
                    </div>
                  </div>
                </div>
              </Col>
              <Col xs={12} sm={1} md={1} lg={1}>
                <div className="mp-between-two-side"></div>
              </Col>
              <Col xs={12} sm={3} md={3} lg={3}>
                <div className="mp-field-container">
                  <div className="mp-label">
                    {`SPOC ${index + 1} email ID`}
                    {index == 0 && <label className="mp-label-red"> *</label>}
                  </div>

                  <TextField
                    id={"service_provider_contact_number_website"}
                    lineDirection="left"
                    placeholder="Type here"
                    disabled={mode == 2}
                    value={e.emailId != "" ? e.emailId : ""}
                    onChange={(elem) => {
                      let data = { ...e, emailId: elem };
                      setSpocData(data, index);
                    }}
                  />
                </div>
              </Col>
              <Col xs={12} sm={1} md={1} lg={1}>
                {index != 0 && (
                  <div
                    className="mp-spoc-remove"
                    onClick={() => {
                      if (mode != 2) {
                        removeSpocRow(index);
                      }
                    }}
                  >
                    <FontIcon style={{ fontSize: "16px" }}>close</FontIcon>
                  </div>
                )}
              </Col>
              <Col xs={12} sm={3} md={3} lg={3}>
                <div
                  className="mp-field-container"
                  style={{ marginTop: "16px" }}
                >
                  <div className="mp-label">{`SPOC ${index + 1} landline`}</div>

                  <TextField
                    id={`service_provider_spoc_landline_${index}`}
                    lineDirection="left"
                    placeholder="Enter landline"
                    disabled={mode == 2}
                    value={e.landline != null ? e.landline : ""}
                    onChange={(elem) => {
                      // Digits plus the separators the API accepts.
                      let data = {
                        ...e,
                        landline: elem.replace(/[^0-9\s-]/g, ""),
                      };
                      setSpocData(data, index);
                    }}
                  />
                </div>
              </Col>
              <Col xs={12} sm={1} md={1} lg={1}>
                <div className="mp-between-two-side"></div>
              </Col>
              <Col xs={12} sm={3} md={3} lg={3}>
                {/* Only service types that have spoc types get the dropdown. */}
                {(spocTypes.length > 0 || e.spocType) && (
                  <div
                    className="mp-field-container"
                    style={{ marginTop: "16px" }}
                  >
                    <div className="mp-label">{`SPOC ${index + 1} type`}</div>
                    <SelectField
                      id={`service_provider_spoc_type_${index}`}
                      placeholder="Select type"
                      className="mp-select-field"
                      disabled={mode == 2}
                      menuItems={getSpocTypeMenuItems(spocTypes, e.spocType)}
                      value={e.spocType != null ? e.spocType : ""}
                      onChange={(elem) => {
                        let data = { ...e, spocType: elem };
                        setSpocData(data, index);
                      }}
                    />
                  </div>
                )}
              </Col>
              {/* Fills the rest of the line so the next SPOC starts a new one. */}
              <Col xs={12} sm={5} md={5} lg={5}>
                <div className="mp-between-two-side"></div>
              </Col>
              {/* Breathing room before the next SPOC entry. */}
              {index !== spocDetails.length - 1 && (
                <Col xs={12}>
                  <div style={{ height: "24px" }}></div>
                </Col>
              )}
            </>
          );
        })}
      </Row>
      <h3 className="mp-sub-heading-margin">{`Address details`}</h3>
      <Row>
        <Col xs={12} sm={3} md={3} lg={3}>
          <div className="mp-field-container">
            <div className="mp-label">
              {`Pincode`}
              <label className="mp-label-red"> *</label>
            </div>

            <TextField
              value={
                providerToCreate?.gymInfo?.address?.pincode
                  ? `${providerToCreate?.gymInfo?.address?.pincode}`
                  : ""
              }
              type="number"
              lineDirection="left"
              placeholder="Type here"
              disabled={mode == 2}
              onChange={(e) => {
                if (e.length <= 6) {
                  if (/^\d+$/.test(e) || e === "") {
                    setProviderToCreate({
                      ...providerToCreate,
                      gymInfo: {
                        ...providerToCreate.gymInfo,
                        address: {
                          ...providerToCreate.gymInfo.address,
                          pincode: Number(e),
                        },
                      },
                    });
                  }

                  // if (e.length == 6) {
                  //   fetchPincodeDetails(e);
                  // }
                }
              }}
            />
          </div>
        </Col>
        <Col xs={12} sm={1} md={1} lg={1}>
          <div className="mp-between-two-side"></div>
        </Col>
        <Col xs={12} sm={3} md={3} lg={3}>
          <div className="mp-field-container">
            <div className="mp-label">
              {`City (This will be displayed on the app)`}
              <label className="mp-label-red"> *</label>
            </div>

            <TextField
              id={"service_provider_address_city"}
              lineDirection="left"
              disabled={mode == 2}
              placeholder="Type here"
              value={
                providerToCreate?.gymInfo?.address?.city
                  ? `${providerToCreate?.gymInfo?.address?.city}`
                  : ""
              }
              onChange={(e) => {
                setProviderToCreate({
                  ...providerToCreate,
                  gymInfo: {
                    ...providerToCreate.gymInfo,
                    address: {
                      ...providerToCreate.gymInfo.address,
                      city: e,
                    },
                  },
                });
              }}
            />
          </div>
        </Col>
        <Col xs={12} sm={1} md={1} lg={1}>
          <div className="mp-between-two-side"></div>
        </Col>
        <Col xs={12} sm={3} md={3} lg={3}>
          <div className="mp-field-container">
            <div className="mp-label">
              {`District`}
              <label className="mp-label-red"> *</label>
            </div>

            <TextField
              id={"service_provider_address_district"}
              lineDirection="left"
              disabled={mode == 2}
              placeholder="Type here"
              value={
                providerToCreate?.gymInfo?.address?.district
                  ? `${providerToCreate?.gymInfo?.address?.district}`
                  : ""
              }
              onChange={(e) => {
                setProviderToCreate({
                  ...providerToCreate,
                  gymInfo: {
                    ...providerToCreate.gymInfo,
                    address: {
                      ...providerToCreate.gymInfo.address,
                      district: e,
                    },
                  },
                });
              }}
            />
          </div>
        </Col>
      </Row>
      <div style={{ height: "20px" }} />
      <Row>
        <Col xs={12} sm={3} md={3} lg={3}>
          <div className="mp-field-container">
            <div className="mp-label">
              {`State`}
              <label className="mp-label-red"> *</label>
            </div>

            <TextField
              id={"service_provider_address_state"}
              lineDirection="left"
              disabled={mode == 2}
              placeholder="Type here"
              value={
                providerToCreate?.gymInfo?.address?.state
                  ? `${providerToCreate?.gymInfo?.address?.state}`
                  : ""
              }
              onChange={(e) => {
                setProviderToCreate({
                  ...providerToCreate,
                  gymInfo: {
                    ...providerToCreate.gymInfo,
                    address: {
                      ...providerToCreate.gymInfo.address,
                      state: e,
                    },
                  },
                });
              }}
            />
          </div>
        </Col>
        <Col xs={12} sm={1} md={1} lg={1}>
          <div className="mp-between-two-side"></div>
        </Col>
        <Col xs={12} sm={3} md={3} lg={3}>
          <div className="mp-field-container">
            <div className="mp-label">{`House No. /Floor /Building`}</div>

            <TextField
              id={"service_provider_address_houseno"}
              lineDirection="left"
              disabled={mode == 2}
              placeholder="Type here"
              value={
                providerToCreate?.gymInfo?.address?.housing
                  ? `${providerToCreate?.gymInfo?.address?.housing}`
                  : ""
              }
              onChange={(e) => {
                setProviderToCreate({
                  ...providerToCreate,
                  gymInfo: {
                    ...providerToCreate.gymInfo,
                    address: {
                      ...providerToCreate.gymInfo.address,
                      housing: e,
                    },
                  },
                });
              }}
            />
          </div>
        </Col>
        <Col xs={12} sm={1} md={1} lg={1}>
          <div className="mp-between-two-side"></div>
        </Col>
        <Col xs={12} sm={3} md={3} lg={3}>
          <div className="mp-field-container">
            <div className="mp-label">{`Colony /Street /Area`}</div>

            <TextField
              id={"service_provider_address_area"}
              lineDirection="left"
              disabled={mode == 2}
              placeholder="Type here"
              value={
                providerToCreate?.gymInfo?.address?.area
                  ? `${providerToCreate?.gymInfo?.address?.area}`
                  : ""
              }
              onChange={(e) => {
                setProviderToCreate({
                  ...providerToCreate,
                  gymInfo: {
                    ...providerToCreate.gymInfo,
                    address: {
                      ...providerToCreate.gymInfo.address,
                      area: e,
                    },
                  },
                });
              }}
            />
          </div>
        </Col>
      </Row>
      <div style={{ height: "20px" }} />
      <Row>
        <Col xs={12} sm={3} md={3} lg={3}>
          <div className="mp-field-container">
            <div className="mp-label">
              {`Locality (This will be displayed on the app)`}
              <label className="mp-label-red"> *</label>
            </div>

            <TextField
              id={"service_provider_address_landmark"}
              lineDirection="left"
              disabled={mode == 2}
              placeholder="Type here"
              value={
                providerToCreate?.gymInfo?.address?.landmark
                  ? `${providerToCreate?.gymInfo?.address?.landmark}`
                  : ""
              }
              onChange={(e) => {
                setProviderToCreate({
                  ...providerToCreate,
                  gymInfo: {
                    ...providerToCreate.gymInfo,
                    address: {
                      ...providerToCreate.gymInfo.address,
                      landmark: e,
                    },
                  },
                });
              }}
            />
          </div>
        </Col>
        <Col xs={12} sm={1} md={1} lg={1}>
          <div className="mp-between-two-side"></div>
        </Col>
        <Col xs={12} sm={7} md={7} lg={7}>
          <div className="mp-field-container">
            <div className="mp-label">{`Google map link`}</div>

            <TextField
              id={"service_provider_address_google_map_link"}
              lineDirection="left"
              disabled={mode == 2}
              placeholder="Type here"
              value={
                providerToCreate?.gymInfo?.address?.googleMapLink
                  ? `${providerToCreate?.gymInfo?.address?.googleMapLink}`
                  : ""
              }
              onChange={(e) => {
                setProviderToCreate({
                  ...providerToCreate,
                  gymInfo: {
                    ...providerToCreate.gymInfo,
                    address: {
                      ...providerToCreate.gymInfo.address,
                      googleMapLink: e,
                    },
                  },
                });
              }}
            />
          </div>
        </Col>
        {providerToCreate?.geolocation?.coordinates?.length === 2 &&
          providerToCreate.geolocation.coordinates.every(
            (v) => typeof v === "number" && v !== 0,
          ) && (
            <>
              <div style={{ height: "20px" }} />
              <Row>
                <Col xs={12} sm={3} md={3} lg={3}>
                  <div className="mp-field-container">
                    <div className="mp-label">Latitude</div>
                    <TextField
                      id="service-provider-address-latitude"
                      lineDirection="left"
                      disabled
                      value={`${providerToCreate.geolocation.coordinates[1]}`}
                    />
                  </div>
                </Col>

                <Col xs={12} sm={1} md={1} lg={1}>
                  <div className="mp-between-two-side" />
                </Col>

                <Col xs={12} sm={3} md={3} lg={3}>
                  <div className="mp-field-container">
                    <div className="mp-label">Longitude</div>
                    <TextField
                      id="service-provider-address-longitude"
                      lineDirection="left"
                      disabled
                      value={`${providerToCreate.geolocation.coordinates[0]}`}
                    />
                  </div>
                </Col>

                <Col xs={12} sm={1} md={1} lg={1}>
                  <div className="mp-between-two-side" />
                </Col>

                <Col xs={12} sm={3} md={3} lg={3}>
                  <div className="mp-field-container">
                    <Button
                      className="zy-btn-blue-1"
                      style={{ maxWidth: "200px", marginTop: "10px" }}
                      onClick={() =>
                        window.open(
                          `https://www.google.com/maps/search/?api=1&query=${providerToCreate.geolocation.coordinates[1]},${providerToCreate.geolocation.coordinates[0]}`,
                          "_blank",
                          "noopener,noreferrer",
                        )
                      }
                    >
                      Redirect to map
                    </Button>
                  </div>
                </Col>
              </Row>
            </>
          )}
      </Row>
      <h3 className="mp-sub-heading-margin">{`Reviews`}</h3>
      <Row>
        <Col xs={12} sm={3} md={3} lg={3}>
          <div className="mp-field-container">
            <div className="mp-label">{`CSAT rating`}</div>

            <TextField
              id={"service_provider_address_rating"}
              lineDirection="left"
              placeholder="Type here"
              disabled={mode == 2}
              type="text"
              value={
                providerToCreate?.gymInfo?.reviewData?.csatRating
                  ? `${providerToCreate?.gymInfo?.reviewData?.csatRating}`
                  : ""
              }
              onChange={(e) => {
                let value1 = e.replace(/\D/g, "");
                const value = value1 === "" ? "" : Number(value1);

                if (
                  value === "" ||
                  (Number.isInteger(value) && value >= 1 && value <= 5)
                ) {
                  setProviderToCreate({
                    ...providerToCreate,
                    gymInfo: {
                      ...providerToCreate.gymInfo,
                      reviewData: {
                        ...providerToCreate.gymInfo.reviewData,
                        csatRating: value === "" ? null : value,
                      },
                    },
                  });
                }
              }}
            />
          </div>
        </Col>
        <Col xs={12} sm={1} md={1} lg={1}>
          <div className="mp-between-two-side"></div>
        </Col>
        <Col xs={12} sm={3} md={3} lg={3}>
          <div className="mp-field-container">
            <div className="mp-label">{`Google review link`}</div>

            <TextField
              id={"service_provider_address_google_review"}
              lineDirection="left"
              placeholder="Type here"
              disabled={mode == 2}
              value={
                providerToCreate?.gymInfo?.reviewData?.googleReviewLink
                  ? `${providerToCreate?.gymInfo?.reviewData?.googleReviewLink}`
                  : ""
              }
              onChange={(e) => {
                setProviderToCreate({
                  ...providerToCreate,
                  gymInfo: {
                    ...providerToCreate.gymInfo,
                    reviewData: {
                      ...providerToCreate.gymInfo.reviewData,
                      googleReviewLink: e,
                    },
                  },
                });
              }}
            />
          </div>
        </Col>
      </Row>

      <h3 className="mp-sub-heading-margin">{`Other information`}</h3>
      <Row>
        <Col xs={12} sm={3} md={3} lg={3}>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
            }}
          >
            <div>
              <Checkbox
                id="mp-checkbox-3"
                name="mp-service-provider-payment-checkbox"
                style={{ marginLeft: -13, marginTop: 3 }}
                disabled={mode == 2}
                color={mode == 2 ? "default" : "secondary"}
                checked={
                  providerToCreate?.gymInfo?.otherInfo
                    ?.advancePaymentRequired != null
                    ? providerToCreate?.gymInfo?.otherInfo
                        ?.advancePaymentRequired
                      ? true
                      : false
                    : false
                }
                onChange={(value, proxy) => {
                  providerToCreate?.gymInfo?.otherInfo
                    ?.advancePaymentRequired == true
                    ? setProviderToCreate({
                        ...providerToCreate,
                        gymInfo: {
                          ...providerToCreate.gymInfo,
                          otherInfo: {
                            ...providerToCreate.gymInfo.otherInfo,
                            advancePaymentRequired: false,
                          },
                        },
                      })
                    : setProviderToCreate({
                        ...providerToCreate,
                        gymInfo: {
                          ...providerToCreate.gymInfo,
                          otherInfo: {
                            ...providerToCreate.gymInfo.otherInfo,
                            advancePaymentRequired: true,
                          },
                        },
                      });
                }}
              />
            </div>
            <div className="mp-label-checkbox">
              {`Advance payment required`}
            </div>
          </div>
        </Col>
        <Col xs={12} sm={1} md={1} lg={1}>
          <div className="mp-between-two-side"></div>
        </Col>
        <Col xs={12} sm={3} md={3} lg={3}>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
            }}
          >
            <div>
              <Checkbox
                id="mp-checkbox-4"
                name="mp-service-provider-auto-booking-confirmation-checkbox"
                style={{ marginLeft: -13, marginTop: 3 }}
                disabled={mode == 2}
                color={mode == 2 ? "default" : "secondary"}
                checked={
                  providerToCreate?.gymInfo?.otherInfo
                    ?.autoBookingConfirmation != null
                    ? providerToCreate?.gymInfo?.otherInfo
                        ?.autoBookingConfirmation
                      ? true
                      : false
                    : false
                }
                onChange={(value, proxy) => {
                  providerToCreate?.gymInfo?.otherInfo
                    ?.autoBookingConfirmation == true
                    ? setProviderToCreate({
                        ...providerToCreate,
                        gymInfo: {
                          ...providerToCreate.gymInfo,
                          otherInfo: {
                            ...providerToCreate.gymInfo.otherInfo,
                            autoBookingConfirmation: false,
                          },
                        },
                      })
                    : setProviderToCreate({
                        ...providerToCreate,
                        gymInfo: {
                          ...providerToCreate.gymInfo,
                          otherInfo: {
                            ...providerToCreate.gymInfo.otherInfo,
                            autoBookingConfirmation: true,
                          },
                        },
                      });
                }}
              />
            </div>
            <div className="mp-label-checkbox">
              {`Automatic confirmation of booking`}
            </div>
          </div>
        </Col>
      </Row>
      <div className="mp-buttons-container mp-sp-city-selection-header-container">
        <h3 ref={enableCityMappingTextRef} className="mp-sub-heading-margin">
          <Checkbox
            id="mp-checkbox-3"
            name="mp-service-provider-payment-checkbox"
            style={{ marginLeft: -13, marginTop: 0 }}
            disabled={mode == 2}
            color={mode == 2 ? "default" : "secondary"}
            checked={
              (providerToCreate?.gymInfo?.cityMapping?.cityMappingEnabled ??
              false)
                ? true
                : false
            }
            onChange={(eve, proxy) => {
              setProviderToCreate({
                ...providerToCreate,
                gymInfo: {
                  ...providerToCreate.gymInfo,
                  cityMapping: {
                    ...providerToCreate?.gymInfo?.cityMapping,
                    cityMappingEnabled: eve.target.checked,
                  },
                },
              });
            }}
          />
          {`Enable city selection`}
        </h3>
        {/* showing save this SP button if initially the city selection was disabled and now we enabled it. */}
        {Boolean(
          !(initialCityMapping?.cityMappingEnabled ?? false) &&
          (providerToCreate?.gymInfo?.cityMapping?.cityMappingEnabled ??
            false) == true &&
          mode == 3,
        ) && (
          <Button
            raised
            disabled={loading}
            className={
              loading ? "mp-button-save-disabled" : "mp-button-save-enabled"
            }
            onClick={() => {
              verifyData();
            }}
          >
            {mode == 1 ? "Save" : "Update"}
          </Button>
        )}
        {Boolean(
          citySectionMode == 2 ||
          !(
            providerToCreate?.gymInfo?.cityMapping?.cityMappingEnabled ?? false
          ) ||
          !(initialCityMapping?.cityMappingEnabled ?? false),
        ) ? (
          <></>
        ) : Boolean(
            cityMappingOperationSelected === 1 ||
            cityMappingOperationSelected === 2,
          ) ? (
          <div className="mp-buttons-right-alignment">
            <Button
              raised
              disabled={loading}
              className={
                loading ? "mp-button-save-disabled" : "mp-button-save-enabled"
              }
              onClick={() => {
                if (cityMappingOperationSelected === 1) {
                  if (checkIfThereIsAnythingToAdd()) {
                    addSPCityMapping();
                  } else {
                    EventService.emit("showError", {
                      message: `Nothing to add. Please add at least 1 city.`,
                    });
                  }
                } else if (cityMappingOperationSelected === 2) {
                  if (checkIfThereIsAnythingToUpdate()) {
                    updateSPCityMapping();
                  } else {
                    EventService.emit("showError", {
                      message: `Nothing to update. Please update at least 1 city.`,
                    });
                  }
                }
              }}
            >
              {"Save"}
            </Button>

            <Button
              raised
              disabled={loading}
              className="mp-button-cancel"
              onClick={() => {
                handleUpdateMode(originalMode);
                setCityMappingOperationSelected(null);
                resetAddOrUpdateCities();
              }}
            >
              {"Cancel"}
            </Button>
          </div>
        ) : (
          <div className="mp-buttons-right-alignment">
            <Button
              raised
              disabled={loading}
              className={
                loading ? "mp-button-save-disabled" : "mp-button-save-enabled"
              }
              onClick={() => {
                handleUpdateMode(2);
                setCityMappingOperationSelected(1);
              }}
            >
              {"Add cities"}
            </Button>
            {Boolean((cityMappings?.cityEntities ?? [])?.length > 0) && (
              <Button
                raised
                disabled={loading}
                className={
                  loading ? "mp-button-save-disabled" : "mp-button-save-enabled"
                }
                onClick={() => {
                  handleUpdateMode(2);
                  setCityMappingOperationSelected(2);
                }}
              >
                {"Update cities"}
              </Button>
            )}
          </div>
        )}
      </div>

      {/* {Boolean(providerToCreate?.gymInfo?.cityMappingEnabled ?? false) && (
        <div className="navigo-appoint-section-6-grid-status">
          <h5>Select operation</h5>
          <SelectField
            id={"mp-service-provider-status"}
            placeholder="Select"
            disabled={
              mode == 2 || loading
            }
            className="mp-select-field"
            menuItems={SERVICE_PROVIDER_CITY_OPERATIONS}
            // defaultValue={"true"}
            value={cityMappingOperationSelected}
            onChange={(e) => setCityMappingOperationSelected((prev) => e)}
          />
        </div>
      )} */}

      {Boolean(
        citySectionMode != 2 &&
        (initialCityMapping?.cityMappingEnabled ?? false) &&
        (providerToCreate?.gymInfo?.cityMapping?.cityMappingEnabled ?? false) &&
        (cityMappingOperationSelected === 1 ||
          cityMappingOperationSelected === 2),
      ) ? (
        <>
          {Boolean(cityMappingOperationSelected === 1) && (
            <>
              <h5>Add city</h5>
              <Row>
                <Col xs={12} sm={3} md={3} lg={3}>
                  <div className="mp-plan-create-service-field-container">
                    <div className="mp-plan-label">
                      {`City`}
                      <label className="account-module-label-red"> *</label>
                    </div>
                    <div>
                      <TextField
                        type="text"
                        value={cityFormData?.cityTextField ?? ""}
                        placeholder="Type here"
                        onChange={(e) => {
                          setCityFormData((prev) => ({
                            ...prev,
                            cityTextField: e,
                          }));
                        }}
                        disabled={citySectionMode == 2}
                        lineDirection="left"
                      />
                    </div>
                  </div>
                </Col>
                <Col xs={12} sm={3} md={3} lg={3}>
                  <div className="mp-plan-create-service-field-container">
                    <div className="mp-plan-label">
                      {`External city ID`}
                      <label className="account-module-label-red"> *</label>
                    </div>
                    <div>
                      <TextField
                        type="text"
                        value={cityFormData?.externalCityId ?? ""}
                        placeholder="Type here"
                        onChange={(e) => {
                          setCityFormData((prev) => ({
                            ...prev,
                            externalCityId: e,
                          }));
                        }}
                        disabled={citySectionMode == 2}
                        lineDirection="left"
                      />
                    </div>
                  </div>
                </Col>
                <Col xs={12} sm={3} md={3} lg={3}>
                  <div className="mp-plan-create-service-field-container">
                    <div className="mp-plan-label">{`External centre ID`}</div>
                    <div>
                      <TextField
                        type="text"
                        value={cityFormData?.externalCentreId ?? ""}
                        placeholder="Type here"
                        onChange={(e) => {
                          setCityFormData((prev) => ({
                            ...prev,
                            externalCentreId: e,
                          }));
                        }}
                        disabled={citySectionMode == 2}
                        lineDirection="left"
                      />
                    </div>
                  </div>
                </Col>
                <Col xs={12} sm={3} md={3} lg={3}>
                  <div style={{ height: "12px" }}></div>
                  <button
                    className="sp-gym-add-city-button"
                    disabled={citySectionMode == 2}
                    onClick={() => {
                      if (!cityFormData?.cityTextField) {
                        EventService.emit("showError", {
                          message: `City field is empty. Cannot add empty city.`,
                        });
                        return;
                      }
                      if (!cityFormData?.externalCityId) {
                        EventService.emit("showError", {
                          message: `Cannot add city with empty External city ID.`,
                        });
                        return;
                      }
                      setCityFormData((prev) => ({
                        ...prev,
                        cityTextField: "",
                        externalCentreId: "",
                        externalCityId: "",
                        cityMappings: [
                          {
                            id: generateId(),
                            city: prev?.cityTextField,
                            externalCentreId: prev?.externalCentreId,
                            externalCityId: prev?.externalCityId,
                            status: 1,
                          },
                          ...(prev?.cityMappings ?? []),
                        ],
                      }));
                    }}
                  >
                    Add
                  </button>
                </Col>
              </Row>

              <br />
              <br />
            </>
          )}
          <CityTable
            tableData={returnTableDataWithEditsApplied(
              cityMappings ?? {},
              tableDataEditAudits ?? {},
            )}
            newTableData={returnNewTableDataWithEditsApplied(
              cityFormData?.cityMappings ?? [],
              newTableDataEditAudits ?? {},
            )}
            cityMappingFilters={cityMappingFilters}
            cityMappings={cityMappings}
            handleUpdateTableData={handleUpdateTableCityEntity}
            handleUpdateNewTableData={handleUpdateNewTableCityEntity}
            cityMappingOperationSelected={cityMappingOperationSelected}
            fetchCityMappings={fetchCityMappings}
            providerToCreate={providerToCreate}
            loading={loading}
          />
        </>
      ) : Boolean(
          (initialCityMapping?.cityMappingEnabled ?? false) &&
          (providerToCreate?.gymInfo?.cityMapping?.cityMappingEnabled ?? false),
        ) ? (
        <CityTable
          tableData={returnTableDataWithEditsApplied(
            cityMappings ?? {},
            tableDataEditAudits ?? {},
          )}
          newTableData={returnNewTableDataWithEditsApplied(
            cityFormData?.cityMappings ?? [],
            newTableDataEditAudits ?? {},
          )}
          cityMappingFilters={cityMappingFilters}
          cityMappings={cityMappings}
          handleUpdateTableData={() => {}}
          handleUpdateNewTableData={() => {}}
          cityMappingOperationSelected={1}
          fetchCityMappings={fetchCityMappings}
          providerToCreate={providerToCreate}
          loading={loading}
        />
      ) : (
        <></>
      )}

      {/* Error Dialog */}
      {Boolean(
        Boolean(errorObject) &&
        Boolean(errorObject?.operation === 1 || errorObject?.operation === 2),
      ) && (
        <div className="modal-overlay">
          <div className="modal error-modal">
            <h3>
              Error{" "}
              {errorObject?.operation === 1
                ? "Adding"
                : errorObject?.operation === 2
                  ? "Updating"
                  : ""}{" "}
              City/Cities
            </h3>
            <div className="error-modal-content" style={{ textAlign: "left" }}>
              <p>
                {(errorObject?.totalRequested ?? 0) -
                  (errorObject?.totalErrors ?? 0)}{" "}
                out of {errorObject?.totalRequested ?? 0} city/cities have been{" "}
                {errorObject?.operation === 1
                  ? "added"
                  : errorObject?.operation === 2
                    ? "updated"
                    : ""}{" "}
                successfully but there are some errors in{" "}
                {errorObject?.totalErrors ?? 0} city/cities, please rectify and
                try again
              </p>

              <div
                style={{
                  maxHeight: "200px",
                  overflowY: "auto",
                  textAlign: "left",
                  paddingRight: "10px",
                }}
              >
                {errorObject?.operation === 1
                  ? Object.entries(errorObject?.errorResponse ?? {}).map(
                      ([city, errMsg], index) => (
                        <div key={index} style={{ marginBottom: "10px" }}>
                          <strong>City:</strong> {city} <br />
                          <strong>Error:</strong> {errMsg}
                        </div>
                      ),
                    )
                  : errorObject?.operation === 2
                    ? Object.entries(errorObject?.errorResponse ?? {}).map(
                        ([key, value], index) => (
                          <div key={index} style={{ marginBottom: "10px" }}>
                            <strong>City:</strong> {value?.city} <br />
                            <strong>Error:</strong> {value?.errorMessage}
                          </div>
                        ),
                      )
                    : ""}
              </div>
            </div>

            <div style={{ height: "32px" }}></div>
            <Button
              raised
              className={"mp-button-save-enabled"}
              onClick={() => setErrorObject(null)}
            >
              {"Okay"}
            </Button>
            <div style={{ height: "32px" }}></div>
          </div>
        </div>
      )}

      {showBackdrop ? <SimpleBackdrop /> : <></>}
    </>
  );
};

export default ServiceProviderGym;
